import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./projects.css";
import serverEndPoint from './../../dxdm';
const sideBoxes = {
  height: "200pt",
  width: "150%",
  backgroundColor: "rgb(233,241,246)",
  marginTop: "10%",
  marginBottom: "10%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export default class Projects extends Component {
  render() {
    return (
      <div style={{ textAlign: "left" }}>
        <div className="row">
          <div
            className="col-sm-12"
            style={{ paddingLeft: "5%", paddingTop: "5%" }}
          >
            <h1 style={{ color: "rgb(40,109,181)" }}>Projects</h1>
          </div>
          <div
            style={{
              paddingLeft: "5%",
              paddingTop: "0%",
              fontSize: "2vh",
              paddingRight: "5%",
            }}
          ></div>
        </div>
        <div style={{ marginLeft: "4%", marginRight: "7%" }}>
          <div className="row">
            <div
              className="col-8"
              style={{ paddingTop: "3%", paddingRight: "5%" }}
            >
              <p style={{ fontSize: "2vh", align: "justify" }}>
                Our engagement with prestigious industry partners and the
                community has led to production of several research projects
                across multiple application domains. The lab members
                with international research collaborators have successfully
                completed a number of joint ventures and presently are engagged
                on following projects that stretch across our research
                streams. The discovery of data sciences within big data is a
                topical issue in industry and academia. Data Insight lab invites students, researchers,
                and companies to explore the opportunities of collaboration and study. To
                discuss any potential projects please contact us.
              </p>
            </div>
            <div className="col-3">

              <div style={sideBoxes}>
                <div style={{ width: "70%" }}>
                  <div>
                    <h3 style={{ color: "rgb(40,109,181)" }}>Our research</h3>
                    <p>
                      {" "}
                      Data science is an area of extensive research as new
                      applications are emerging from Industry.
                    </p>
                    <Link to={`/our-research`}
                    // <Link to={`${serverEndPoint}/our-research`}
                      className="btn btn-primary"
                      style={{
                        borderRadius: "20pt",
                        paddingLeft: ">0pt",
                        paddingRight: ">0pt",
                      }}
                    >
                      {" "}
                      <b>FIND OUT MORE</b>{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-12">
            <ul style={{ display: "flex", flexWrap: "wrap" }}>
              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltleft.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/diagnosis.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Asthma Prediction & Diagnosis
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  Early detection of worsening asthma aims to
                                  predict daily asthma related ED visits and
                                  admissions. The project will help in predicting the adverse
                                  impact of social factors such as overcrowding on asthma outcomes
                                  and inform proactive measures by health providers and organizations.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/shopping.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Smart Shopping
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  The overall objective of this research project is to
                                  enable brick and mortar (BaM) retailers to track what
                                  their customers are looking at, so that they can better withstand the
                                  pressures of online retail. This gives BaM retailers unprecedented
                                  insight into optimal sales processes.{" "}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltleft.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/bigdata.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Bridging gap b/w Real-time&Historic Big Data
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  In Real-Time Data Warehousing a fast stream of customer's sales transactions
                                  needs to be joined with a disk-based Master Data
                                  before loading it to the Data Warehouse. In this project we present novel approaches
                                  for caching and load shedding streaming data.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltleft.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/deepbaskit.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Deep Baskit Analysis
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  The project aims to develop a near-real-time analytic tool called
                                  MAFIS (Mining Abstraction for Frequent Itemsets) for analysisng the stream of shopping data
                                  using big-data technologies. The unique opportunity to trial such technologies will enable
                                  us to validate it and gather realistic data.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/medical.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Medical Adherence
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  An aging and overweight population has shifted the industry focus
                                  from acute care to chronic disease management, this requires self-management.
                                  This project conducted studies
                                  using technology to uplift medical adherence by sending medical-adherence reminders and raising awareness.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>



              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltleft.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/investigate.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Forensic Intelligence
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  The project's primary goal is to analyse ESR's forensic casework data to identify patterns
                                  in the types, timing and outputs of the forensic science conducted.
                                  The outcome of the project will help to improve the way New Zealand prevents, responses
                                  and supports the recovery from crime.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/hospital.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Post Discharge Application
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  Discharging from the hospital is the most critical period for patient.
                                  The aim of the project was to develop a post
                                  discharge application. The application will enhance efficiency and effectiveness
                                  of communicated information leading to better recovery for patients.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
{/*  comment*/}

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/datawarhousing.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Real-time Data Warehousing
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                 In Real-Time Data Warehousing (RTDM) typically a fast input stream of customer's sales transactions from Operational Data Sources (ODSs) needs to be joined with a disk-based Master Data (MD) before loading it to RTDM. These semi-stream join approaches typically perform the join with a limited main memory partition assigned to them, which is generally not large enough to hold the whole MD.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/power.jpg`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Forecasting Fluctuation in Power Supply
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  Electric power systems' frequency stability is impacted by demand and generation fluctuations. Maintaining stability requires matching generation with demand to prevent frequency spikes caused by abrupt demand surges or generation drops. The research aims to identify precursor patterns in variables like generation load and demand that lead to frequency spikes.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>


              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/sol.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Staged Online Learner (SOL)
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                   Improve real-time data stream analysis by enhancing throughput and accuracy using the Staged Online Learner (SOL) framework. This addresses challenges organizations face in making timely decisions due to current batch processing of streaming data. The project earned a partial 2016 AUT SRIF award.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

           {/*    hh */}

           <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltedright.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/travel.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  Travel Data Analytics
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  
Our travel data analysis centers on GPS-based travel surveys, crucial for shaping travel infrastructure like roads, trains, and more. These surveys have gained traction for accurate time and location data. However, challenges include costs, user adherence, and signal limitations in some areas.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>

              <li className="projectSlide">
                <table
                  style={{
                    height: "50%",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundImage: `url(${serverEndPoint}/images/tiltleft.png)`,
                          width: "200px",
                          height: "260pt",
                          backgroundSize: "cover",
                        }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{ height: "71pt", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img src={`${serverEndPoint}/images/crime.png`} alt="" style={{ height: "80%" }} />
                                </div>
                                <h4
                                  style={{
                                    paddingLeft: "20pt",
                                    marginBottom: "-5pt",
                                    paddingBottom: "20pt",
                                    color: "#286DB5",
                                  }}
                                >
                                  A Smart way to Find Similar Crimes
                                </h4>
                                <p
                                  style={{
                                    paddingLeft: "20pt",
                                    paddingRight: "10pt",
                                    fontSize: "1.8vh",
                                  }}
                                >
                                  The project developes Similar Crimes Identifier (SCI) for finding similarities between the crimes using AI and Ontology.
                                  The SCI provides a visual relationships between similar crime.
                                  We achieve similar crime patterns and represent these into a knowledge graph.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}